import Modal from "@/components/Modal";
import DatePicker from '@components/FormFields/DatePicker';
import PriceInput from '@components/FormFields/PriceInput';
import Button from '@components/DesignLibrary/Button';
import CustomSelect from '@components/FormFields/CustomSelect';
import { useEffect, useState } from "react";
import * as ApiModels from '@typings/api-models';
import { DEFAULT_CURRENCY } from '@typings/common';
import commonStyles from '@modals/ModalsCommon.module.scss';
import { ApiDefinition } from '@noodleApi';

const DIFFERENCE_ACTION = [
  {
    key: 'carryForward',
    title: 'Carry forward to the next installment',
    value: 'carryForward',
  },
  {
    key: 'split',
    title: 'Split among upcoming installments',
    value: 'split',
  },
  {
    key:'reduceFromLast',
    title:'Reduce from last installments',
    value:'reduceFromLast',
  },
];
type InstallmentDataProps ={
    invoice: ApiDefinition['/invoices/{id}']['GET']['response'];
    onClose: () => void;
    handleSubmit: (data:{
      differenceAction:string;
      expectedAmount: number;
      expectedDate: string,
      paymentPlanId:string,
      paymentPlanPaymentId: string,
    }) => Promise<void>;
    installmentData:
      & Pick<ApiModels.PaymentPlanPayment,
        | 'id'
        | 'expectedAmount'
        | 'expectedDate'
        | 'paymentPlanId'
      >
      & { index: number };
    paymentPlanPayments: Array<Pick<ApiModels.PaymentPlanPayment,
      | 'expectedAmount'
      | 'expectedDate'
    >>;
    fetchingState: {
      isFetching: boolean;
      isFetched: boolean;
      fetchingTime: number | null;
  }
  };
const EditInstallmentModal:React.FC<InstallmentDataProps> = ({
  onClose,
  handleSubmit,
  installmentData,
  invoice,
  paymentPlanPayments,
  fetchingState,
}) => {
  const [amount, setAmount] = useState(installmentData.expectedAmount);
  const [differenceAction, setDifferenceAction] = useState(DIFFERENCE_ACTION[0].value);
  const [dueDate, setDueDate] = useState<string>(installmentData?.expectedDate);
  const [optionDisable,setOptionDisable] = useState(false);
  const [differenceActionOptions,setDifferenceActionOptions] = useState(DIFFERENCE_ACTION?.filter(action => action.value!=='reduceFromLast'));

  useEffect(() => {
    if(amount>installmentData.expectedAmount) {
      setDifferenceActionOptions(DIFFERENCE_ACTION);
      setOptionDisable(true);
      setDifferenceAction('reduceFromLast');
    }
    else{
      setDifferenceActionOptions(DIFFERENCE_ACTION?.filter(action => action.value!=='reduceFromLast'));
      setOptionDisable(false);
      setDifferenceAction(DIFFERENCE_ACTION[0].value);
    }
  },[amount]);

  const giveMaxPrice = ():number => {
    if(installmentData?.index !== 0 ) {
      const reserved = paymentPlanPayments?.slice(0,installmentData?.index)?.reduce((acc,curr) => acc+curr.expectedAmount,0);
      if(reserved) {
        return Number((invoice.amountDue-reserved).toFixed(2));
      }
    }
    return invoice?.amountDue;
  };

  const giveMinDate = ():string => {
    const targetIndex = installmentData.index;
    if(targetIndex>=1) {
      const targetDateForMin = new Date(paymentPlanPayments[targetIndex-1].expectedDate);
      targetDateForMin.setDate(targetDateForMin.getDate()+1);
      return targetDateForMin.toISOString().split('T')[0];
    }
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  const giveMaxDate = ():string => {
    const targetIndex = installmentData.index;
    if(targetIndex+1<paymentPlanPayments.length) {
      const targetDateForMax = new Date(paymentPlanPayments[targetIndex+1].expectedDate);
      targetDateForMax.setDate(targetDateForMax.getDate()+1);
      return targetDateForMax.toISOString().split('T')[0];
    }
    return '';
  };

  return (
    <Modal
      hideBottomInset
      title='Edit Installment'
      onClose={onClose}
    >
      <div className={commonStyles.container} style={{ gap: 16, paddingTop: 40 }}>
        <DatePicker max={giveMaxDate()} min={giveMinDate()} value={dueDate} onChange={setDueDate} label='Due Date' />
        <PriceInput currency={DEFAULT_CURRENCY} name='amount' onChange={setAmount} value={Number(amount.toFixed(2))} max={giveMaxPrice()} label='Amount' />
        <CustomSelect disabled={optionDisable} label='Choose the difference action' value={differenceAction} id='differenceAction' onChange={newAction => setDifferenceAction(newAction)} options={differenceActionOptions} />
        <Button
          variant='primary'
          size='md'
          fullWidth
          loading={fetchingState.isFetching}
          onClick={() => {
            handleSubmit({
              differenceAction,
              expectedAmount: amount,
              expectedDate: dueDate,
              paymentPlanId:installmentData.paymentPlanId,
              paymentPlanPaymentId: installmentData?.id,
            });
          }}
        >
              Save
        </Button>
      </div>
    </Modal>
  );

};
export default EditInstallmentModal;